import * as React from "react";
import { FunctionComponent } from "react";
import { Card } from "react-bootstrap";
import { CardContent, CardHeader, CardTitle } from "../../components/ui/card";

interface Props {
  title: string;
  mainContent: string;
  additionalContent: string;
}
export const DashboardCard: FunctionComponent<Props> = ({
  title,
  mainContent,
  additionalContent,
}) => {
  return (
    <Card className="max-h-48 w-[150px] p-1 overflow-hidden dark:bg-slate-900">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium dark:text-white min-w-36 text-ellipsis overflow-hidden whitespace-nowrap">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold dark:text-white text-ellipsis overflow-hidden">
          {mainContent}
        </div>
        <p className="text-xs text-muted-foreground text-ellipsis overflow-hidden">
          {additionalContent}
        </p>
      </CardContent>
    </Card>
  );
};
